import { render, staticRenderFns } from "./ManageContacts.vue?vue&type=template&id=33603656&scoped=true"
import script from "./ManageContacts.vue?vue&type=script&lang=js"
export * from "./ManageContacts.vue?vue&type=script&lang=js"
import style0 from "./ManageContacts.vue?vue&type=style&index=0&id=33603656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33603656",
  null
  
)

export default component.exports